const eSignatureInitAcademicYear = 27;
export { eSignatureInitAcademicYear };
